import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

export const FolderBusinessEntityListCmp_ThirdParty_Fragment = graphql(`
  fragment FolderBusinessEntityListCmp_ThirdParty_Fragment on ThirdParty {
    __typename
    _id
    color
    kind

    ... on Person {
      fullName
      lastName
      firstName
      civilityId
      pictureImageUri
    }

    ... on Organization {
      name
      tradingName
      identifier {
        kind
        value
      }
      logoImageUri
    }
  }
`);

export type FolderBusinessEntityListCmp_ThirdParty = ResultOf<
  typeof FolderBusinessEntityListCmp_ThirdParty_Fragment
>;
